export default (...reducers) => (state, action) =>
  reducers.reduce((prevState, r) => r(prevState, action), state);



// WEBPACK FOOTER //
// ./src/core/redux/decorators/mergeReducers.js